//actions sur les messages
export const PENDING_STORE = 'PENDING_STORE'
export const SUCCESS_STORE = 'SUCCESS_STORE'
export const FAIL_STORE = 'FAIL_STORE'
export const RESET_MESSAGE_STORE = 'RESET_MESSAGE_STORE'

//Action sur l'authentification
export const LOGIN_STORE = 'LOGIN_STORE'
export const LOGOUT_STORE = 'LOGOUT_STORE'

//Actions sur les services
export const SAVE_SERVICE_STORE = 'SAVE_SERVICE_STORE'
export const UPDATE_SERVICE_STORE = 'UPDATE_SERVICE_STORE'
export const LISTER_SERVICES_STORE = 'LISTER_SERVICES_STORE'
export const TOGGLE_MODAL_SERVICE = 'TOGGLE_MODAL_SERVICE'
export const DELETE_SERVICE_STORE = 'DELETE_SERVICE_STORE'

//Actions sur les templates
export const SAVE_TEMPLATE_STORE = 'SAVE_TEMPLATE_STORE'
export const UPDATE_TEMPLATE_STORE = 'UPDATE_TEMPLATE_STORE'
export const LISTER_TEMPLATES_STORE = 'LISTER_TEMPLATES_STORE'
export const TOGGLE_MODAL_TEMPLATE = 'TOGGLE_MODAL_TEMPLATE'
export const DELETE_TEMPLATE_STORE = 'DELETE_TEMPLATE_STORE'

//Actions sur les groupes
export const SAVE_GROUPE_STORE = 'SAVE_GROUPE_STORE'
export const UPDATE_GROUPE_STORE = 'UPDATE_GROUPE_STORE'
export const LISTER_GROUPES_STORE = 'LISTER_GROUPES_STORE'
export const TOGGLE_MODAL_GROUPE = 'TOGGLE_MODAL_GROUPE'
export const DELETE_GROUPE_STORE = 'DELETE_GROUPE_STORE'

//Actions sur les impressions
export const SAVE_IMPRESSION_STORE = 'SAVE_IMPRESSION_STORE'
export const LISTER_IMPRESSIONS_STORE = 'LISTER_IMPRESSIONS_STORE'
